// Webrtc plugin.
import * as actionTypes from '../actionTypes'

// Libraries.
import { combineActions, handleActions } from 'redux-actions'
import { concat, remove } from 'lodash/fp'

const reducers = {}

reducers[actionTypes.SESSION_ADDED] = {
  next (state, action) {
    return concat(state, action.payload)
  }
}

reducers[actionTypes.SESSION_REMOVED] = {
  next (state, action) {
    const removeSession = session => session.id === action.payload.id
    return remove(removeSession)(state)
  }
}

const sessionReducers = {}

sessionReducers[actionTypes.SESSION_NEW_TRACK] = {
  next (state, action) {
    if (action.payload.local) {
      return {
        ...state,
        localTracks: concat(state.localTracks, [action.payload.trackId])
      }
    } else {
      return {
        ...state,
        remoteTracks: concat(state.remoteTracks, [action.payload.trackId])
      }
    }
  }
}

sessionReducers[actionTypes.SESSION_TRACK_ENDED] = {
  next (state, action) {
    const removeTrack = trackId => trackId === action.payload.trackId
    if (action.payload.local) {
      return {
        ...state,
        localTracks: remove(removeTrack, state.localTracks)
      }
    } else {
      return {
        ...state,
        remoteTracks: remove(removeTrack, state.remoteTracks)
      }
    }
  }
}

sessionReducers[actionTypes.SESSION_TRACK_REPLACED] = {
  next (state, action) {
    // Remove old track id if it still exists
    const removeTrack = trackId => trackId === action.payload.oldTrackId
    const newLocalTracks = remove(removeTrack, state.localTracks)
    // Add new track id if it doesn't exist
    if (newLocalTracks.indexOf(action.payload.trackId) === -1) {
      newLocalTracks.push(action.payload.trackId)
    }
    return {
      ...state,
      localTracks: newLocalTracks
    }
  }
}

const sessionReducer = handleActions(sessionReducers, {})

const specificSessionActions = combineActions(
  actionTypes.SESSION_NEW_TRACK,
  actionTypes.SESSION_TRACK_ENDED,
  actionTypes.SESSION_TRACK_REPLACED
)

reducers[specificSessionActions] = (state, action) => {
  return state.map(session => {
    if (session.id === action.payload.id) {
      return sessionReducer(session, action)
    } else {
      return session
    }
  })
}

/*
 * Combine all of top-tier reducers into a single reducer,
 *      each with a default state of an empty array.
 */
const reducer = handleActions(reducers, [])
export default reducer
